/**
 * set
 */

import Page from '~/page/page';
import Slider from '~/slider/slider';

export default class Set extends Slider {
  init() {
    const elements = {
      slider: '.js-set-slides',
      prev: '.js-set-prev',
      next: '.js-set-next'
    };

    setTimeout(() => {
      this.set(elements);
    }, 200);
  }
  static in($node) {
    return Boolean($node.find('.js-set').length);
  }
  static is($node) {
    return $node.is('.js-set');
  }
  static find($node) {
    return $node.find('.js-set');
  }
  static get selector() {
    return '.js-set';
  }
}

Page.mount(Set, '.js-set');
